module.exports = __webpack_public_path__ + "static/media/icon_nav_on_patient.b6f5e45a.svg";